import { Dispatch, useCallback, useEffect } from 'react'

import { useDispatch } from 'react-redux'
import { onWindowFocus } from 'shared/store/actions/platform'

import { RootAction } from 'typesafe-actions'

const useWindowFocus = () => {
  const dispatch = useDispatch<Dispatch<RootAction>>()

  const focusFunction = useCallback(
    (_: FocusEvent) => {
      dispatch(onWindowFocus())
    },
    [dispatch]
  )

  useEffect(() => {
    window.addEventListener('focus', focusFunction)
    return () => {
      window.removeEventListener('focus', focusFunction)
    }
  }, [focusFunction])
}

export default useWindowFocus
